import { render, staticRenderFns } from "./CodeButton.vue?vue&type=template&id=61a8d69e&"
import script from "./CodeButton.vue?vue&type=script&lang=js&"
export * from "./CodeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports